export default __webpack_public_path__ + "static/media/s5.416b5f1c.jpg";